/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */

import SurveyProgress, { AnimationVariant } from '@features/survey-progress';
import { UniversalTrackerValuePlain } from '@g17eco/types/universalTrackerValue';
import { getSurveyQuestionProgressFromUtrvs } from '../../../../utils/survey';

interface AssessmentProgressProps {
  utrvs: Pick<UniversalTrackerValuePlain, 'status' | '_id'>[];
  showSummary?: boolean;
}

export const AssessmentProgress = ({ utrvs, showSummary = true }: AssessmentProgressProps) => {
  const progressStats = getSurveyQuestionProgressFromUtrvs(utrvs);

  return (
    <div className='flex-fill'>
      <div className='w-100 d-flex'>
        <div className='flex-grow-1 pr-3'>
          <SurveyProgress {...progressStats} animationVariant={AnimationVariant.Animated} />
          {showSummary ? (
            <div className='text-sm text-right text-ThemeTextMedium mt-1'>
              <span>
                answered{' '}
                <span className='dont_translate'>
                  {progressStats.completed}/{progressStats.count}
                </span>
              </span>
              <span className='px-3'>|</span>
              <span>
                verified{' '}
                <span className='dont_translate'>
                  {progressStats.verified}/{progressStats.count}
                </span>
              </span>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};
